import AppStoreLinks from "./AppStoreLinks";
import "../styles/AboutView.css";

const AboutView = () => {
  return (
    <main className="landing-page">
      <section className="hero">
        <div className="hero__content">
          <p className="eyebrow">Your next favorite beer starts here</p>
          <h1>Discover, share, and remember every great pour.</h1>
          <p className="hero__lede">
            CRAFT brings beer lovers together to explore breweries, share
            tasting moments, and build a personal cellar worth talking about.
          </p>
          <AppStoreLinks />
          <p className="age-note">For people of legal drinking age.</p>
        </div>

        <div className="hero-preview" aria-label="A preview of CRAFT features">
          <div className="hero-preview__glow" />
          <div className="preview-card preview-card--primary">
            <span className="preview-card__label">DISCOVER</span>
            <strong>Fresh finds from the CRAFT community</strong>
            <div className="preview-post">
              <span className="preview-post__avatar">C</span>
              <span>
                <b>Explore a new pour</b>
                <small>Beer, breweries, people, and groups</small>
              </span>
            </div>
          </div>
          <div className="preview-card preview-card--secondary">
            <span className="preview-card__label">MY CELLAR</span>
            <strong>Keep your collection close</strong>
          </div>
        </div>
      </section>

      <section className="feature-section" aria-labelledby="feature-heading">
        <p className="eyebrow">Made for the beer-curious</p>
        <h2 id="feature-heading">More ways to enjoy the community around every glass.</h2>
        <div className="feature-grid">
          <article className="feature-card">
            <span className="feature-card__number">01</span>
            <h3>Discover</h3>
            <p>Browse beers, breweries, people, and groups before you even start searching.</p>
          </article>
          <article className="feature-card">
            <span className="feature-card__number">02</span>
            <h3>Share</h3>
            <p>Post your latest tasting, join the conversation, and follow fellow beer enthusiasts.</p>
          </article>
          <article className="feature-card">
            <span className="feature-card__number">03</span>
            <h3>Collect</h3>
            <p>Build a personal cellar and keep the beers you care about organized in one place.</p>
          </article>
        </div>
      </section>

      <section className="landing-cta">
        <div>
          <p className="eyebrow">Ready when you are</p>
          <h2>Bring better beer discovery with you.</h2>
        </div>
        <AppStoreLinks />
      </section>
    </main>
  );
};

export default AboutView;
